// SCRIPT TO SHOW AND HIDE SEARCH FORM 
/*document.addEventListener('DOMContentLoaded', function() {
    const buttonSearch = document.getElementById('toggle-search')
    const searchForm = document.querySelector (".search-form-container");

    if (buttonSearch){
        buttonSearch.addEventListener('click', (e) => {
            searchForm.classList.toggle("show");
            buttonSearch.classList.toggle("hideElement");
            e.stopPropagation(); // Prevent event from reaching document.body
        });        
    }

     // Add event listener to the document body for clicks
     document.body.addEventListener('click', (e) => {
        // Check if the clicked element is not the search form, the button, or any of their descendants
        if (!searchForm.contains(e.target) && e.target !== buttonSearch) {
            searchForm.classList.remove('show');
            buttonSearch.classList.remove('hideElement');
        }
    });

}, false);*/


// SCRIPT TO SHOW AND HIDE SEARCH FORM 
document.addEventListener('DOMContentLoaded', function() {
    const buttonsSearch = document.querySelectorAll('.toggle-search');
    const searchForms = document.querySelectorAll(".search-form-container");

    buttonsSearch.forEach((buttonSearch, index) => {
        buttonSearch.addEventListener('click', (e) => {
            searchForms[index].classList.toggle("show");
            buttonSearch.classList.toggle("hideElement");
            e.stopPropagation(); // Prevent event from reaching document.body
        });
    });

    // Add event listener to the document body for clicks
    document.body.addEventListener('click', (e) => {
        // Check if the clicked element is not any of the search forms, the buttons, or any of their descendants
        let isInsideForm = false;
        searchForms.forEach((searchForm) => {
            if (searchForm.contains(e.target)) {
                isInsideForm = true;
            }
        });

        if (!isInsideForm && !Array.from(buttonsSearch).some((buttonSearch) => buttonSearch.contains(e.target))) {
            searchForms.forEach((searchForm) => {
                searchForm.classList.remove('show');
            });
            buttonsSearch.forEach((buttonSearch) => {
                buttonSearch.classList.remove('hideElement');
            });
        }
    });

}, false);

